import React, {useState, useCallback, useEffect} from 'react';
import {Button, Input, Space, Modal,Image,Upload,message,Card,Row, Col} from 'antd';
import {useNavigate} from 'react-router-dom'
import {YunyingUploader} from '../../components/Uploader'
import Api from "../../api";
const { Meta } = Card;
message.config({
    top: 100,
    duration: 2,
    maxCount:1,
    rtl: true,
})
export default function TeacherIndex () {

    const navigate = useNavigate();
    const [listTotal, setListTotal] = useState([])
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [schoolName,setSchoolName] = useState("")
    useEffect(()=>{
       loadData();
    },[])

    const doSearch = useCallback((options) => {
        setSchoolName(options.schoolName)
        const filterlist = listTotal.filter( item => item.title.indexOf(options.schoolName)!=-1);
        setList(filterlist)
    })


    const loadData = useCallback(()=>{
        if (loading) return;
        setLoading(true)
        Api.getPictureLibList()
        .then(resp=>{
            setLoading(false)
            setListTotal(resp.list||[])
            const filterlist = resp.list.filter(item => item.title.indexOf(schoolName)!=-1);
            setList( filterlist||[] )
        })
    })


    const update = useCallback((record) => {
        navigate('/school/'+record.id)
    })

    const deleteItem = useCallback((record) => {
        Modal.confirm({
            title: '确认删除？',
            content: record.title,
            okText: '是',
            okType: 'danger',
            cancelText: '否',
            onOk() {
                Api.deletePictureLib(record.id).then(res=>{
                    if(res.resultCode==1){
                        const totallist = listTotal.filter( item => item.id!=record.id);
                        const filterlist = totallist.filter( item => item.title.indexOf(schoolName)!=-1);
                        setList(filterlist)
                        setListTotal(totallist)
                        message.success(res.resultMessage)
                    }
                })
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    })

    return (
        <div style={{minWidth: 900}}>
            <SearchBar onSearch={doSearch} loadData={loadData} defaultValue={schoolName}/>
            <Row gutter={[16,8]}>
                {
                    list.map(item=>{
                        return(
                            <Col>
                                <Card key={`school${item.id}`} style={{ width: 300, marginTop: 16 }} loading={loading}>
                                <Meta
                                avatar={<Image width={70} height={70} src={item.picUrl} />}
                                title={<span title={item.id+" "+item.title}>{item.id+" "+item.title}</span>}
                                description={<><Button type="link" onClick={() => update(item)}>编辑</Button><Button type="link" style={{color:"red"}} onClick={() => deleteItem(item)}>删除</Button></>}
                            />
                        </Card>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    );
};

function SearchBar({onSearch, defaultValue,loadData}) {
    const [schoolName,setSchoolName] = useState(defaultValue)
    let count = 0;
    let arr = [];
    const doSearch = useCallback(()=>{
        onSearch && onSearch({
            schoolName
        })
    })
    const doReset = useCallback(()=>{
        setSchoolName("");
        onSearch && onSearch({schoolName:""})
    })
    const onResult = useCallback((res,length)=>{
        count++;
        arr.push(res)
        if(count==length){
            Api.pictureLibBatchAdd(arr).then(_=>{
                count = 0;
                arr = [];
                loadData&&loadData();
            })
        }
    })
    return (
        <div className="white-bg pdh16 pdv32 mgv12">
            <div className="flexbox wrap align-center mgb12">
                <div>
                    <span>高校名称：</span>
                    <Input
                        value={schoolName}
                        onChange={(e)=>setSchoolName(e.target.value)}
                        placeholder="请输入" style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <Space>
                    <Button type="primary" onClick={doSearch}>查询</Button>
                    <Button  onClick={doReset}>重置</Button>
                    <YunyingUploader type="00" onResult={onResult}>
                            {<><Button>上传Logo</Button><span>（按住 ctrl 可选择多个图片，图片命名为单位名，换行需"-"隔开，例如：吉林师范大学-博达学院）</span></>}
                    </YunyingUploader>
                </Space>
            </div>
        </div>
    )
}

